import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { getSummaryDetailsUrl, submitSummaryFormUrl, SUBMIT_SUMMARY_FORM, GET_SUMMARY_DETAILS, headers } from "../../utils/constants"
import moment from 'moment';

export const get_summary_details_action = (userID, OrderID) => async (dispatch) => {
    try {
        const mapdata = {
            userID: parseInt(userID),
            OrderID: OrderID,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getSummaryDetailsUrl, mapdata, headers);

        dispatch({
            type: GET_SUMMARY_DETAILS,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const submit_summary_form_action = (userID, OrderID, email, name, center, bookingDates, bookingSlot, selectedhrs, details) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(userID),
            OrderID: OrderID,
            email: email,
            username: name,
            center: center,
            bookingDates: bookingDates,
            bookingSlot: bookingSlot,
            selectedhrs: selectedhrs,
            details: details,
        }
        console.log("data----------", mapdata)
        const res = await axiosPost(submitSummaryFormUrl, mapdata, headers);

        dispatch({
            type: SUBMIT_SUMMARY_FORM,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};